import {
  Paper,
  Stack,
  Button,
  Modal,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import AlertModal from "../../../../../componentes/alertModal";
import { validateIp } from "../../../../../utils/validateIp";

export default function EditModalRouter(params) {
  const {
    setOpenEditModal,
    openEditModal,
    setSnackbar,
    setLoadingTable,
    styles,
    selectedRow,
    setErrorName,
    errorName,
    comparaOutrosNomes,
    handleEditRouters,
  } = params;
  const [disableEditButton, setDisableEditButton] = useState(false);
  const [nomeBgp, setNomeBgp] = useState("");
  const [modo, setModo] = useState("");
  const [ipFlows, setIpFlows] = useState("");
  const [taxaAmostragemV4, setTaxaAmostragemV4] = useState("");
  const [taxaAmostragemV6, setTaxaAmostragemV6] = useState("");
  const [snmpIp, setSnmpIp] = useState("");
  const [snmpCommunity, setSnmpCommunity] = useState("");
  const [snmpPort, setSnmpPort] = useState("");
  //alert modal
  const [confirmarEdicao, setConfirmarEdicao] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  useEffect(() => {
    if (selectedRow) {
      setNomeBgp(selectedRow.nome_bgp);
      setModo(selectedRow.modo);
      setIpFlows(selectedRow.ip_flows);
      setTaxaAmostragemV4(selectedRow.taxa_amostragem_v4);
      setTaxaAmostragemV6(selectedRow.taxa_amostragem_v6);
      setSnmpIp(selectedRow.snmp_ip);
      setSnmpCommunity(selectedRow.snmp_community);
      setSnmpPort(selectedRow.snmp_port);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (
      comparaOutrosNomes(nomeBgp, selectedRow.nome_bgp) ||
      !modo ||
      validateIp(ipFlows) === 0 ||
      !taxaAmostragemV4 ||
      !taxaAmostragemV6 ||
      validateIp(snmpIp) === 0 ||
      !snmpCommunity ||
      !snmpPort
    ) {
      setDisableEditButton(true);
    } else {
      setDisableEditButton(false);
    }
  }, [
    nomeBgp,
    modo,
    ipFlows,
    taxaAmostragemV4,
    taxaAmostragemV6,
    snmpIp,
    snmpCommunity,
    snmpPort,
  ]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && disableEditButton === false) {
      handleApiPutRouter();
    }
  };
  const handleHelperText = (ip) => {
    if (ip) {
      return validateIp(ip) === 1
        ? "O endereço IPv4 é válido!"
        : validateIp(ip) === 2
        ? "O endereço IPv6 é válido!"
        : "Formato de IP inválido";
    }
    return null;
  };
  async function handleApiPutRouter() {
    try {
      setLoadingTable(true);
      setDisableEditButton(true);
      const response = await api.put("/relatoriosFlow/router/update", {
        id: selectedRow.id,
        nome_bgp: nomeBgp,
        modo,
        ip_flows: ipFlows,
        taxa_amostragem_v4: parseInt(taxaAmostragemV4),
        taxa_amostragem_v6: parseInt(taxaAmostragemV6),
        snmp_ip: snmpIp,
        snmp_community: snmpCommunity,
        snmp_port: parseInt(snmpPort),
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível salvar dados",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Dados Salvos com sucesso",
          severity: "success",
        });
        if (response.data) {
          handleEditRouters(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setLoadingTable(false);
      setDisableEditButton(false);
      setOpenEditModal(false);
      setConfirmarEdicao(false);
      setOpenAlertModal(false);
    }
  }
  return (
    <>
      <Modal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
          setErrorName(false);
        }}
        sx={{ alignItems: "center", justifyContent: "center", display: "flex" }}
      >
        <Paper sx={styles.paperModal} elevation={3}>
          <DialogTitle color="primary">Edite Router </DialogTitle>{" "}
          <DialogContent sx={styles.dialogContent}>
            <Stack direction="row" spacing={"20px"} sx={{ mt: 1 }}>
              <TextField
                sx={{ width: "100%" }}
                id="textfield-nome-bgp"
                label="Nome Router"
                //type="number"
                value={nomeBgp}
                error={errorName}
                helperText={errorName ? "Nome é uma chave única" : null}
                onChange={(e) => {
                  if (
                    comparaOutrosNomes(e.target.value, selectedRow.nome_bgp)
                  ) {
                    setErrorName(true);
                  } else {
                    setErrorName(false);
                  }
                  setNomeBgp(e.target.value);
                }}
              />
            </Stack>
            <Stack direction="row" spacing={"20px"}>
              <FormControl sx={styles.TextField}>
                <InputLabel>Modo</InputLabel>
                <Select
                  value={modo}
                  label="Modo"
                  onChange={(event) => {
                    setModo(event.target.value);
                  }}
                >
                  <MenuItem value={"nfcapd"}>{"nfcapd"}</MenuItem>
                  <MenuItem value={"sfcapd"}>{"sfcapd"}</MenuItem>
                </Select>
              </FormControl>
              <TextField
                sx={styles.TextField}
                id="textfield-ip"
                label="Source IP"
                value={ipFlows}
                error={ipFlows ? !validateIp(ipFlows) : false}
                helperText={handleHelperText(ipFlows)}
                onChange={(e) => setIpFlows(e.target.value)}
              />
            </Stack>
            <Stack direction="row" spacing={"20px"}>
              <TextField
                sx={styles.TextField}
                id="textfield-taxa-amostragem-v4"
                label="Amostragem V4"
                type="number"
                value={taxaAmostragemV4}
                onChange={(e) => setTaxaAmostragemV4(e.target.value)}
              />
              <TextField
                sx={styles.TextField}
                id="textfield-taxa-amostragem-v6"
                label="Amostragem V6"
                type="number"
                value={taxaAmostragemV6}
                onChange={(e) => setTaxaAmostragemV6(e.target.value)}
              />
            </Stack>
            <Stack direction="row" spacing={"20px"}>
              <TextField
                sx={{ width: "100%" }}
                id="textfield-snmp-community"
                label="SNMP Community"
                value={snmpCommunity}
                onChange={(e) => setSnmpCommunity(e.target.value)}
              />
            </Stack>
            <Stack direction="row" spacing={"20px"}>
              <TextField
                sx={styles.TextField}
                id="textfield-snmp-ip"
                label="SNMP IP"
                value={snmpIp}
                error={snmpIp ? !validateIp(snmpIp) : false}
                helperText={handleHelperText(snmpIp)}
                onChange={(e) => setSnmpIp(e.target.value)}
              />
              <TextField
                sx={styles.TextField}
                id="textfield-snmp-port"
                label="SNMP Port"
                type="number"
                value={snmpPort}
                onKeyDown={handleKeyDown}
                onChange={(e) => setSnmpPort(e.target.value)}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() => {
                setOpenEditModal(false);
                setErrorName(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              disabled={disableEditButton}
              onClick={() => {
                setOpenAlertModal(true);
                // handleApiPutRouter();
              }}
            >
              Editar
            </Button>
          </DialogActions>
        </Paper>
      </Modal>
      <AlertModal
        openModal={openAlertModal}
        setOpenModal={setOpenAlertModal}
        confirmar={confirmarEdicao}
        handleButton={handleApiPutRouter}
        severity={"warning"}
        singleButton={false}
      />
    </>
  );
}
